import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './app/ErrorBoundary';
import './index.css';
// Theme-aware chip/avatar/dot pairs — loaded after index.css so both files'
// :root blocks resolve before first paint.
import './core/ui/palette.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found.');

// The phone release: register the worker that receives pushes and routes
// notification taps to the exact comment (?pm= is read in App boot). Silent
// no-op on browsers without SW. Registration is independent of push
// permission — permission is asked only by the user's own tap on "Enable
// notifications" in the sidebar.
// "Share to CG Projects" (v1.78.0): Instagram's share sheet lands here as
// /?share-title=…&share-text=…&share-url=…. Stash it for the capture bar and
// scrub the URL.
try {
  const qp = new URLSearchParams(window.location.search);
  if (qp.has('share-url') || qp.has('share-text') || qp.has('share-title')) {
    sessionStorage.setItem('cgp:share', JSON.stringify({
      title: (qp.get('share-title') ?? '').slice(0, 200),
      text: (qp.get('share-text') ?? '').slice(0, 1000),
      url: (qp.get('share-url') ?? '').slice(0, 1000),
    }));
    window.history.replaceState(null, '', window.location.pathname + window.location.hash);
  }
} catch { /* cosmetic */ }

// A push tap arrives as /?pm=<messageId>#/t/<taskId> — the search param is
// the "which comment" half of the deep link (it can't ride inside the hash
// without breaking the route grammar). Stash it for TaskComments and scrub
// the URL so a reload doesn't re-flash.
try {
  const pm = new URLSearchParams(window.location.search).get('pm');
  if (pm && /^\d+$/.test(pm)) {
    void import('@/features/task-detail/store/taskDetailStore').then((m) => {
      m.useTaskDetailStore.getState().setFocusMessage(Number(pm));
    });
    window.history.replaceState(null, '', window.location.pathname + window.location.hash);
  }
} catch { /* cosmetic */ }

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
